<script lang="ts">
  import Pin from "../../assets/icons/pin.svg";
  import type { SearchAddressPrediction } from "../../lib/api/address";

  export let prediction: SearchAddressPrediction;
  export let predictionSelected: (prediction: SearchAddressPrediction) => void;
</script>

<button class="py-3 px-4 flex pointer max-w-full" on:click={() => predictionSelected(prediction)}>
  <img src={Pin} class="px-2 self-center" alt="Pin" />
  <p class="address-text text-ellipsis whitespace-nowrap overflow-hidden">
    <span class="prediction-main-text grow">{prediction.address1}</span>
    <span class="prediction-secondary-text grow-0">{`${prediction.city}, ${prediction.state} ${prediction.zip}, ${prediction.country}`}</span>
  </p>
</button>

<style>
  .prediction-secondary-text,
  .address-text {
    color: var(--color-grayscale-50);
  }

  .prediction-main-text {
    color: black;
  }
</style>
